import { useGetAccounts } from '../../../api/lending/lapiHooks';

export const useGetANTFormalOffers = () => {
  const { accounts, loadingAccounts } = useGetAccounts();

  const antFormalOffers =
    accounts?.accounts?.flatMap((account) => {
      if (account.product_type === 'iwocapay') return [];
      if (account.loan_offer_id !== account.latest_formal_offer?.offer_id) {
        return account.latest_formal_offer?.is_valid
          ? [account.latest_formal_offer]
          : [];
      }
      return [];
    }) || [];

  return {
    antFormalOffers,
    loadingANTFormalOffers: loadingAccounts,
  };
};
